/**
 * Format a date as a short relative time label (e.g. "Just now", "5m ago",
 * "3h ago", "2d ago"). For dates older than a week, falls back to the
 * locale's short date string.
 *
 * Originally lifted from DiagramHistoryPanel; reused by VersionsPanel and any
 * other timeline UI that wants the same look-and-feel.
 *
 * @param {string|Date|number|null|undefined} dateInput - ISO string, Date, or
 *   epoch ms. Falsy values yield an empty string.
 * @returns {string}
 */
export function formatRelativeTime(dateInput) {
  if (!dateInput) return '';
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
  if (Number.isNaN(date.getTime())) return '';

  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;
  return date.toLocaleDateString();
}

export default formatRelativeTime;
